import { anyOf, objectOf, recordOf } from "@altostra/type-validations";
import { nullOrUndefined, string } from "@altostra/type-validations/lib/primitives";

export const isPostAppGroupIdFigmaImagesResult = objectOf({
  err: nullOrUndefined,
  images: recordOf<Record<string, string | null>>(anyOf(string, nullOrUndefined)),
});
